<div class="header bg-primary pb-6">
  <div class="container-fluid">
    <div class="row align-items-center py-4">
      <div class="col-lg-6 col-7">
        <h1 class="text-white d-inline-block mb-0">
          <i class="fas fa-bolt mr-2"></i>Automations
        </h1>
      </div>
      <div class="col-lg-6 col-5 text-right">
        <button class="btn btn-success" (click)="openNewAgentModal()">
          <i class="fas fa-plus mr-2"></i>New agent
        </button>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt--6">
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col-md-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Search agents..."
              [(ngModel)]="searchTerm" />
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-control" [(ngModel)]="selectedApp">
            <option>Any app</option>
            <option>Jira</option>
            <option>Slack</option>
            <option>Gmail</option>
            <option>Google Docs</option>
          </select>
        </div>
        <div class="col-md-3">
          <select class="form-control" [(ngModel)]="sortField">
            <option value="dateCreated">Date created</option>
            <option value="name">Name</option>
            <option value="lastRun">Last run</option>
          </select>
        </div>
        <div class="col-md-2 text-right">
          <div class="btn-group">
            <button
              class="btn"
              [class.btn-primary]="viewMode === 'grid'"
              [class.btn-outline-primary]="viewMode !== 'grid'"
              (click)="viewMode = 'grid'">
              <i class="fas fa-th-large"></i>
            </button>
            <button
              class="btn"
              [class.btn-primary]="viewMode === 'list'"
              [class.btn-outline-primary]="viewMode !== 'list'"
              (click)="viewMode = 'list'">
              <i class="fas fa-list"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <ng-container *ngIf="viewMode === 'grid'">
        <div class="row">
          <div
            class="col-md-4 mb-4"
            *ngFor="let agent of sortAgents(filterAgents())">
            <div class="card h-100">
              <div class="card-body">
                <div
                  class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="card-title mb-0">{{ agent.name }}</h5>
                  <span
                    class="badge"
                    [class.badge-success]="agent.status === 'active'"
                    [class.badge-danger]="agent.status === 'inactive'">
                    {{ agent.status }}
                  </span>
                </div>
                <div class="apps mb-3">
                  <span
                    class="badge badge-light mr-1"
                    *ngFor="let app of agent.apps">
                    {{ app }}
                  </span>
                </div>
                <p class="card-text text-muted">
                  <small>Last run: {{ agent.lastRun | date : 'medium' }}</small>
                </p>
              </div>
              <div
                class="card-footer bg-transparent d-flex justify-content-end">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-outline-primary">
                    <i class="fas fa-play"></i> Run now
                  </button>
                  <button class="btn btn-outline-primary">
                    <i class="fas fa-cog"></i>
                  </button>
                  <button class="btn btn-outline-danger">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="viewMode === 'list'">
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th>Name</th>
                <th>Apps</th>
                <th>Last Run</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let agent of sortAgents(filterAgents())">
                <td>{{ agent.name }}</td>
                <td>
                  <span
                    class="badge badge-light mr-1"
                    *ngFor="let app of agent.apps">
                    {{ app }}
                  </span>
                </td>
                <td>{{ agent.lastRun | date : 'medium' }}</td>
                <td>
                  <span
                    class="badge"
                    [class.badge-success]="agent.status === 'active'"
                    [class.badge-danger]="agent.status === 'inactive'">
                    {{ agent.status }}
                  </span>
                </td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-primary">
                      <i class="fas fa-play"></i>
                    </button>
                    <button class="btn btn-outline-primary">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button class="btn btn-outline-danger">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
</div>
